<ng-container *ngIf="serverError">
  <div class="modal-header">
    <h4 class="modal-title">Server Error: {{ serverError }}</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
</ng-container>

<ng-container *ngIf="notFound">
  <div class="modal-header">
    <h4 class="modal-title">Not Found</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
</ng-container>

<ng-container *ngIf="!(serverError || notFound)">

  <div class="modal-header">
    <h4 class="modal-title">Potential Duplicate Customer</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body pb-0" *ngIf="loadingDup">
    <p>Loading...</p>
  </div>

  <div class="modal-body pb-0" *ngIf="!loadingDup">

    <p>
      <b>
        New Customer
        <span *ngIf="thisCustomerId === dup.new_customer_id">(this customer)</span>
      </b>
      <br>
      Name:
      <a *ngIf="dup.status !== PotentialDuplicateCustomerStatus.merged"
         [routerLink]="['/customers', dup.new_customer_id.toString()]"
         target="_blank">
        {{ dup.new_customer_first_name }} {{ dup.new_customer_last_name }}
      </a>
      <span *ngIf="dup.status === PotentialDuplicateCustomerStatus.merged">
        {{ dup.new_customer_first_name }} {{ dup.new_customer_last_name }}
      </span>
      <br>
      Birthday: {{ dateStringFromISO8601(dup.new_customer_birthday) }} <br>
      Email:
      <span *ngIf="dup.new_customer_email">{{ dup.new_customer_email }}</span>
      <span *ngIf="!dup.new_customer_email" class="text-muted">None</span>
      <br>
      Created:
      {{ timeStringFromISO8601(dup.new_customer_created_at, orgConfig.getOrganizationConfig().time_zone) }},
      {{ dateStringFromISO8601(dup.new_customer_created_at, orgConfig.getOrganizationConfig().time_zone) }}
    </p>

    <p>
      <b>
        Existing Customer
        <span *ngIf="thisCustomerId === dup.existing_customer_id">(this customer)</span>
      </b>
      <br>
      Name:
      <a [routerLink]="['/customers', dup.existing_customer_id.toString()]"
         target="_blank">
        {{ dup.existing_customer_first_name }} {{ dup.existing_customer_last_name }}
      </a>
      <br>
      Birthday: {{ dateStringFromISO8601(dup.existing_customer_birthday) }} <br>
      Email:
      <span *ngIf="dup.existing_customer_email">{{ dup.existing_customer_email }}</span>
      <span *ngIf="!dup.existing_customer_email" class="text-muted">None</span>
      <br>
      Created:
      {{ timeStringFromISO8601(dup.existing_customer_created_at, orgConfig.getOrganizationConfig().time_zone) }},
      {{ dateStringFromISO8601(dup.existing_customer_created_at, orgConfig.getOrganizationConfig().time_zone) }}
    </p>

    <div *ngIf="dup.status === PotentialDuplicateCustomerStatus.pendingAction" class="mb-3">
      <div class="form-check">
        <input class="form-check-input" type="radio" id="mergeInput"
               [value]="StaffAction.merge" [(ngModel)]="selectedAction">
        <label class="form-check-label" for="mergeInput">
          Merge new customer into existing customer.
        </label>
      </div>
      <div class="form-check">
        <input class="form-check-input" type="radio" id="dismissInput"
               [value]="StaffAction.dismiss" [(ngModel)]="selectedAction">
        <label class="form-check-label" for="dismissInput">
          Keep both customers (dismiss potential duplicate).
        </label>
      </div>
      <div class="form-check" *ngIf="showHideOption && !dup.hidden_by_id">
        <input class="form-check-input" type="radio" id="hideInput"
               [value]="StaffAction.hide" [(ngModel)]="selectedAction">
        <label class="form-check-label" for="hideInput">
          Hide from inbox.
        </label>
      </div>
    </div>

    <p *ngIf="dup.merged_by_id">
      Merged by
      {{ getStaffNameDisplay(dup.merged_by_first_name, dup.merged_by_last_name, dup.merged_by_email) }}
      at
      {{ timeStringFromISO8601(dup.merged_at, orgConfig.getOrganizationConfig().time_zone) }},
      {{ dateStringFromISO8601(dup.merged_at, orgConfig.getOrganizationConfig().time_zone) }}
    </p>

    <p *ngIf="dup.dismissed_by_id">
      Dismissed by
      {{ getStaffNameDisplay(dup.dismissed_by_first_name, dup.dismissed_by_last_name, dup.dismissed_by_email) }}
      at
      {{ timeStringFromISO8601(dup.dismissed_at, orgConfig.getOrganizationConfig().time_zone) }},
      {{ dateStringFromISO8601(dup.dismissed_at, orgConfig.getOrganizationConfig().time_zone) }}
    </p>

    <p *ngIf="dup.hidden_by_id">
      Hidden by
      {{ getStaffNameDisplay(dup.hidden_by_first_name, dup.hidden_by_last_name, dup.hidden_by_email) }}
      at
      {{ timeStringFromISO8601(dup.hidden_at, orgConfig.getOrganizationConfig().time_zone) }},
      {{ dateStringFromISO8601(dup.hidden_at, orgConfig.getOrganizationConfig().time_zone) }}
    </p>

    <div *ngIf="dup.status === PotentialDuplicateCustomerStatus.pendingAction"
         class="alert alert-info mb-3">
      <a href="#"
         (click)="$event.preventDefault();navigateToMergePage();">
        Click here to open the Merge Customers page for this duplicate.
      </a>
      This will allow you to view more information about the merge, as well as swap which customer is merged.
    </div>

    <div class="alert alert-info mb-3"
         *ngIf="(thisCustomerId === dup.new_customer_id) && (selectedAction === StaffAction.merge)">
      This merge will remove the currently opened customer profile in favor of the existing customer. You will be redirected to the existing customer's profile.
    </div>

    <div class="alert alert-danger mb-3" role="alert" *ngIf="errorMessage">
      {{ errorMessage }}
    </div>

  </div>

  <div class="modal-footer">

    <button type="button" class="btn btn-secondary"
            (click)="activeModal.close()">
      Close
    </button>
    <button type="button" class="btn btn-primary"
            *ngIf="!(loadingSubmit || loadingDup) && (dup.status === PotentialDuplicateCustomerStatus.pendingAction)"
            (click)="handleSave()"
            [disabled]="!validInputSelected()"
            [class.disabled]="!validInputSelected()">
      Save
    </button>
    <button type="button" class="btn btn-primary disabled" disabled
            *ngIf="loadingSubmit || loadingDup">
      Loading...
    </button>

  </div>

</ng-container>
